import { useEffect, useState } from 'react';
import { Triangle } from 'react-loader-spinner';

// eslint-disable-next-line
const Spinner = ({ loading, texts = [], colour }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    let spinnerColour = '#1F75FA';

    if (colour === 'green') {
        spinnerColour = '#006b00';
    }
    useEffect(() => {
        let interval;

        if (loading && texts.length > 0) {
            interval = setInterval(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % texts.length);
            }, 1000);
        } else {
            setCurrentIndex(0);
        }

        return () => clearInterval(interval);
    }, [loading, texts]);

    return (
        <>
            {loading && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999,
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        textAlign: 'center'
                    }}
                >
                    <Triangle
                        visible={loading}
                        height="80"
                        width="80"
                        color={spinnerColour}
                        ariaLabel="triangle-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                    />
                    {texts.length > 0 && <p style={{ marginTop: '20px', fontSize: '18px', color: '#333' }}>{texts[currentIndex]}</p>}
                </div>
            )}
        </>
    );
};

export default Spinner;
